import { render, staticRenderFns } from "./ExternalSound.vue?vue&type=template&id=2ac1253b"
import script from "./ExternalSound.vue?vue&type=script&lang=js"
export * from "./ExternalSound.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports